import { createContext } from "react";
import Company from "../../../../../app/domain/Company";
import companyContextInterface from "./types";

const CompanyContext = createContext<companyContextInterface>({
  company: new Company({}),
  isLoading: true,
  setCompany: () => {},
  setIsLoading: () => {},
});

export default CompanyContext;
